import React from 'react';
import styled from 'styled-components';

export const CancelIcon = styled.div`
  width: 1.092vw;
  height: 1.092vw;
  opacity: ${(props) => (props.selected ? '0' : '1')};
  cursor: pointer;
  position: absolute;
  top: calc(50% - 0.546vw);
  left: ${(props) => (props.rtlDirection ? 'unset' : props.display ? '0' : '1.6vw')};
  right: ${(props) => (props.rtlDirection ? (props.display ? '0' : '1.6vw') : 'unset')};
  transform: ${(props) => (props.display ? 'rotate(0deg)' : 'rotate(360deg)')};
  -webkit-transition: 200ms linear;
  -ms-transition: 200ms linear;
  transition: 200ms linear;
  
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 1.2vw;
`;

export const StartingCostWrapper = styled.div`
  background-color: ${(props) => props.theme.pure};
  position: relative;
  width: 23.633vw;
  padding-bottom: 7.548vw;
  border-radius: 1.56vw;
  margin: auto;
  margin-top: 0.56vw;
`;

export const StartingCostWrapperText = styled.div`
  color: ${(props) => props.theme.textPrimary};
  font-size: 0.728vw;
  font-weight: 500;
  position: absolute;
  left: 0;
  bottom: ${(props) => props.bottom};
  width: 100%;
  padding-left: ${(props) => (props.rtlDirection ? '1.04vw' : '2.967vw')};
  padding-right: ${(props) => (props.rtlDirection ? '2.967vw' : '1.04vw')};
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.56vw;
`;

export const OrderWrapper = styled.div`
  color: ${(props) => props.theme.textPrimary};
  font-size: 0.728vw;
  font-weight: 500;
  position: relative;
  width: 22.663vw;
  height: 7.391vw;
  margin: auto;
  margin-top: 0.56vw;
  display: inline-block;

   &:hover {
    ${CancelIcon} {
      color: ${(props) => props.theme.icons};
    }
`;

export const OrderLeftSide = styled.img`
  position: absolute;
  top: 0;
  left: ${(props) => (props.rtlDirection ? 'unset' : '0')};
  right: ${(props) => (props.rtlDirection ? '0' : 'unset')};
  width: 9.37vw;
  height: 100%;
  object-fit: cover;
`;

export const OrderRightSide = styled.div`
  position: absolute;
  top: 0;
  right: ${(props) => (props.rtlDirection ? 'unset' : '0')};
  left: ${(props) => (props.rtlDirection ? '0' : 'unset')};
  width: 11.749vw;
  height: 100%;
`;

export const Ordertext = styled.div`
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) =>
    props.rtlDirection ? (props.right ? props.right : 'unset') : props.left ? props.left : 'unset'};
  right: ${(props) =>
    props.rtlDirection ? (props.left ? props.left : 'unset') : props.right ? props.right : 'unset'};
  font-size: ${(props) => props.fontSize};
  width: ${(props) => props.width};
  text-align: ${(props) => (props.rtlDirection ? 'right' : 'left')};
  overflow: hidden;
  // white-space: nowrap;  is commented for showing the rest of the text on a new line
  text-overflow: ellipsis;
`;

export const OrderWrapperBox = styled.div`
  position: absolute;
  top: 0;
  right: ${(props) => (props.rtlDirection ? 'unset' : '0')};
  left: ${(props) => (props.rtlDirection ? '0' : 'unset')};
  width: 21.118vw;
  height: 7.391vw;
  border-radius: 1.56vw;
  overflow: hidden;
  background-color: ${(props) => props.theme.cardBackground};
`;

export const OrdersWrapper = styled.div`
  overflow: auto;
  width: calc(100% - 1.04vw);
  height: ${(props) => (props.checkoutMode ? '23.5vw' : 'calc(100vh - 20vw)')};
  position: absolute;
  top: ${(props) => (props.checkoutMode ? '3.48vw' : '6.35vw')};
  left: ${(props) => (props.rtlDirection ? 'unset' : '0')};
  right: ${(props) => (props.rtlDirection ? '0' : 'unset')};
  text-align: center;
  ::-webkit-scrollbar {
    width: 0.624vw;
    border-radius: 0.624vw;
    background-color: ${(props) => props.theme.SecondaryBackground};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 0.26vw ${(props) => props.theme.SecondaryBackground};  */
    border-radius: 0.624vw;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.borderBackground};
    border: 0vw solid #f4f4f4;
    border-radius: 0.624vw;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.tagBorder};
  }
`;

export const ButtonWrapper = styled.div`
  position: relative;
  width: 5.361vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DeleteWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  padding-top: 1.926vw;
  padding-bottom: 1.926vw;
  color: ${(props) => props.theme.textPrimary};
  font-size: 0.832vw;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  top: ${(props) => (props.display ? '0' : '-30%')};
  opacity: ${(props) => (props.display ? '1' : '0')};
  visibility: ${(props) => (props.display ? 'visible' : 'hidden')};
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  transition: 200ms ease-in-out;
`;
